import { defineComponent as _defineComponent } from 'vue';
import { renderTrustedMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var showBenefitsQuantifyingGhg = ref(false);
    return {
      __sfc: true,
      showBenefitsQuantifyingGhg: showBenefitsQuantifyingGhg,
      renderTrustedMarkdown: renderTrustedMarkdown
    };
  }
});